fragment TravelersFields on Traveler {
  id
  __typename
  _urgencyLevel
  _isDeletable
  _rowTimestamp
  _sortName
  vendorNumber
  userOccupation {
    userOccupationTitle
  }
  travelPolicy {
    id
    description
  }
  department {
    name
  }
  approvalHistoriesByEntityId(orderBy: REQUESTED_DATE_DESC) {
    nodes { 
      id
      requesterName
      requestedDate
      amount1
      currencyIsoCode
      isApprovalTreeViewerAllowed
      iconType {
        iconType
        iconState
      }
      statusType {
        statusType
      }
    }
  }
  travelerAddressesByTravelerId(orderBy: IS_PRIMARY_DESC) {
    nodes {
      id
      _rowTimestamp
      addressLine1
      addressLine2
      cityName
      countryId
      stateRegionId
      stateRegion {
        stateRegionDescription
        stateRegion
        country {
          country
        }
      }
      country {
        country
      }
      postalCode
      telephoneNumber
      emailAddress
      isGroundTransferAddress
      isDeliveryAddress
      isPrimary
    }
  }
  statusType {
    statusType
    approvalState
    _transactionIconStatus
  }
  _isStagedApprovalRequest
}
